import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { endpointWithPath, getHealthCheck } from "../util/health.js";
const title = 'Postscript';
const serviceProvider = {
    name: 'postscript',
    title,
    description: 'SMS marketing platform for ecommerce companies.',
    categories: ['sms', 'marketing'],
    links: [{ title: 'Homepage', url: 'https://postscript.io/' }],
    serviceType: 'openapi',
    introspectionType: 'openapi',
    createId: value('postscript'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '^[0-9a-z_-]+$',
                default: 'postscript'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: title
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: title
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    token: {
                        title: 'API Private Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        },
        required: ['title', 'id', 'namespace', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable title for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'A unique, url-safe identifier for this service.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'API Private Key from https://app.postscript.io/account/api'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? title,
            namespace: formData.namespace ?? title,
            provider: 'postscript',
            serviceType: 'openapi',
            authenticationType: 'bearer',
            options: {
                endpoint: 'https://api.postscript.io/',
                spec: 'https://raw.githubusercontent.com/takeshape/openapi-specs/d459ffcd591a923805cc3bdeba77a725eb4831a4/specs/postscript/v2.yml',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json'
                }
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.endpoint', 'options.spec']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: endpointWithPath('/api/v2/subscribers')
    })
};
export default serviceProvider;
